import {activateHouse, deleteHouse, loadAllHouses, regenerateHouse} from "../actions/houseActions";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import HouseList from "../components/HouseList";
import {push} from "react-router-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_DELETE_HOUSE, PROC_LOAD_HOUSES, PROC_UPDATE_HOUSE} from "../actions";
import {showSnackbar} from "../actions/snachbarActions";

const m2s = state => ({
	houses: state.house.list,
	isDeleting: (id) => isProcessing(state, PROC_DELETE_HOUSE, id),
	isUpdating: (id) => isProcessing(state, PROC_UPDATE_HOUSE, id),
	isloading: isProcessing(state, PROC_LOAD_HOUSES),
});
const m2d = dispatch => ({
	onLoad: () => dispatch(loadAllHouses()),
	onSelect: (house) => dispatch(push(`/houses/${house.house_id}`)),
	onCreate: () => dispatch(push('/houses/createData')),
	onDelete: (id, onSuccess) => dispatch(deleteHouse(id, result => {
		onSuccess && onSuccess(result);
		dispatch(showSnackbar('snackbar.house.deleted'));
	})),
	onRegenerate: (house, onSuccess) => dispatch(regenerateHouse(house.house_id || house, result => {
		onSuccess && onSuccess(result);
		dispatch(showSnackbar('snackbar.house.regenerated'));
	})),
	onActivate: (house, active, onSuccess) => dispatch(activateHouse(house, active, result => {
		onSuccess && onSuccess(result);
		dispatch(showSnackbar('snackbar.house.state-changed'));
	}))
	// isDeleting: (id) => dispatch(isProcessDispatch(PROC_DELETE_HOUSE, id))
});

export default connect(m2s, m2d)(translate()(HouseList));


// WEBPACK FOOTER //
// ./src/containers/HouseListController.js